<template>
    <div class="base-card__content credit-content base-card__zoom">
        <div class="credit-content__wrapper base-card__shadow">
            <img 
                v-if="imageUrl" 
                :key="imageUrl"
                loading="lazy"
                alt=""
                class="credit-content__image"
                :src="imageUrl"
            >
            <common-icon v-else class="credit-content__image" :icon-name="'IconNoPerson'" />
        </div>
        <div class="base-card__shift credit-content__name">
            {{ title }}
        </div>
        <div class="credit-content__descr">{{ subTitle }}</div>
    </div>
</template>

<script setup lang="ts">
    import type { PropType, Ref } from "vue";
    import type { CreditCardData } from "../../models";
    import { ref, computed } from "vue";
 

    const props = defineProps({
        cardData: {
            type: Object as PropType<CreditCardData>,
            required: true
        },
    });

    const cardImage: Ref<string | null> = ref(props.cardData.getImage());
    const title: string = props.cardData.getName();
    const subTitle: string = props.cardData.getDescription();

    const imageUrl = computed({
        get: (): string => {
            if (!cardImage.value) {
                return '';
            } else {
                return `${cardImage.value}&width=${260}`;
            }
        },
        set: (newValue: string): void => {
            cardImage.value = newValue;
        }
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>